import Axios from "axios";
import {
    SET_INV_DIRECT_RECEIVE_LIST,
    UNSET_INV_DIRECT_RECEIVE_LIST,
  } from "@/store/mutation-types";
import {saveUpdateInvDirectReceive, getInvDirectReceiveList, getInvDirectReceiveById as getInvDirectReceiveByIdApi } from "@/store/api";
// initial state
const state = {
  getInvDirectReceiveList: [],
  editingRequisition: null,
};

const getters = {
  getInvDirectReceiveList(state) {
    return state.getInvDirectReceiveList;
  },
  getEditingReceive(state) { 
    return state.editingRequisition;
  },
};

const mutations = {
  [SET_INV_DIRECT_RECEIVE_LIST](state, data) {
    state.getInvDirectReceiveList = data;
  },
  [UNSET_INV_DIRECT_RECEIVE_LIST](state) {
    state.getInvDirectReceiveList = [];
  },
  setEditingDirectReceive(state, requisition) {
    state.editingRequisition = requisition;
  },
};

const actions = {
  saveUpdateInvDirectReceive({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateInvDirectReceive, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getInvDirectReceiveList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getInvDirectReceiveList, data)
        .then(function (response) {
          commit('SET_INV_DIRECT_RECEIVE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_INV_DIRECT_RECEIVE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getInvDirectReceiveById({ commit }, id) {
    const getInvDirectReceiveById = `${getInvDirectReceiveByIdApi}/${id}`;
    return new Promise((resolve, reject) => {
      Axios.post(getInvDirectReceiveById)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
